import PreviewGraySvg from "@/src/assets/icons/icon-preview-gray.svg";
import PreviewSvg from "@/src/assets/icons/icon-preview-indigo.svg";
import { IconButton } from "@/src/components/atom/Button";
import Icon from "@/src/components/atom/Icon";
import { useMemo, useCallback, useEffect, useState } from "react";

interface PreviewFileButtonProps {
  mediaUrl?: string | null;
  buttonSize?: number;
  buttonColor?: "blue" | "black" | "gray" | "red" | "yellow" | "green";
  buttonGrade?: "primary" | "secondary" | "tertiary";
}

function PreviewFileButton({
  mediaUrl,
  buttonSize = 24,
  buttonColor = "blue",
  buttonGrade = "secondary",
}: PreviewFileButtonProps) {
  // Ensure hydration-safe behavior if SSR is introduced later
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const hasValidUrl = useMemo(() => {
    if (!isClient || !mediaUrl) return false;
    try {
      // Using window.location.origin as a base allows for relative URLs to be parsed correctly.
      const url = new URL(mediaUrl, window.location.origin);
      return ["http:", "https:", "blob:"].includes(url.protocol);
    } catch {
      return false;
    }
  }, [isClient, mediaUrl]);

  const handleClick = useCallback(() => {
    if (hasValidUrl && mediaUrl) {
      window.open(mediaUrl, "_blank", "noopener,noreferrer");
    }
  }, [hasValidUrl, mediaUrl]);

  return (
    <IconButton
      buttonSize={buttonSize}
      buttonColor={buttonColor}
      buttonGrade={buttonGrade}
      disabled={!hasValidUrl}
      onClick={handleClick}
    >
      <Icon iconSrc={hasValidUrl ? PreviewSvg : PreviewGraySvg} iconSize={16} />
    </IconButton>
  );
}

export default PreviewFileButton;